import Header from '@components/Header';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import useAppCustom from '@hooks/useAppCustom';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useStepFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import CouponHistoryFragment from './fragments/CouponHistoryFragment';
import DownloadCouponFragment from './fragments/DownloadCouponFragment';
import ExternalCouponFragment from './fragments/ExternalCouponFragment';
import MyCouponFragment from './fragments/MyCouponFragment';
import PaperCouponFragment from './fragments/PaperCouponFragment';

interface Params {
    type: 'MY' | 'DOWNLOAD' | 'HISTORY' | 'EXTERNAL' | 'PAPER';
}

declare module '@stackflow/config' {
    interface Register {
        CouponActivity: Params;
    }
}

const CouponActivity: ActivityComponentType<'CouponActivity'> = ({ params }) => {
    const { type } = params;
    const { t } = useTranslation('coupon');
    const { replaceStep } = useStepFlow('CouponActivity');
    const { useExternalCouponInCoupon } = useAppCustom().coupon;
    return (
        <AppScreen>
            <Header title={t('title')} />
            <TabList variant='solid'>
                <TabItem selected={type === 'MY'}
                    onClick={() => replaceStep({ type: 'MY' })}>
                    {t('tabs.my')}
                </TabItem>
                <TabItem selected={type === 'DOWNLOAD'}
                    onClick={() => replaceStep({ type: 'DOWNLOAD' })}>
                    {t('tabs.download')}
                </TabItem>
                {useExternalCouponInCoupon && (
                    <TabItem selected={type === 'EXTERNAL'}
                        onClick={() => replaceStep({ type: 'EXTERNAL' })}>
                        {t('tabs.external')}
                    </TabItem>
                )}
                <TabItem selected={type === 'PAPER'}
                    onClick={() => replaceStep({ type: 'PAPER' })} >
                    {t('tabs.paper')}
                </TabItem>
                <TabItem selected={type === 'HISTORY'}
                    onClick={() => replaceStep({ type: 'HISTORY' })}>
                    {t('tabs.history')}
                </TabItem>
            </TabList>
            {type === 'MY' && (
                <MyCouponFragment/>
            )}
            {type === 'DOWNLOAD' && (
                <DownloadCouponFragment/>
            )}
            {type === 'HISTORY' && (
                <CouponHistoryFragment/>
            )}
            {type === 'EXTERNAL' && (
                <ExternalCouponFragment/>
            )}
            {type === 'PAPER' && (
                <PaperCouponFragment/>
            )}
        </AppScreen>
    );
};

export default CouponActivity;
